import { render, staticRenderFns } from "./PriceWarningTable.vue?vue&type=template&id=2465d548"
import script from "./PriceWarningTable.vue?vue&type=script&lang=js"
export * from "./PriceWarningTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports